"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Link = _interopRequireDefault(require("../common/Link"));
var _Container = _interopRequireDefault(require("../Container"));
var _emailUtils = require("../../../../utils/emailUtils");
var _Partner = require("../../contexts/Partner");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var images = {
  desktop: (0, _emailUtils.getImage)('search_form.png'),
  mobile: (0, _emailUtils.getImage)('search_form_mobile.jpg')
};
var imageStyle = function imageStyle(type) {
  return {
    height: type === 'mobile' ? '340px' : '200px',
    display: type === 'mobile' ? 'none' : 'block',
    widht: '100%',
    backgroundImage: "url(".concat(images[type], ")"),
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  };
};
var styles = {
  desktopImage: {
    width: '100%'
  }
};
var SearchForm = function SearchForm() {
  var _useContext = (0, _react.useContext)(_Partner.PartnerContext),
    link = _useContext.link;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: link
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "desktop-only-block",
    src: images.desktop,
    style: styles.desktopImage,
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: imageStyle('mobile'),
    className: "mobile-only-block"
  })));
};
var _default = exports["default"] = SearchForm;